interface LoadingSpinnerProps {
  size?: number;
  className?: string;
}

export function LoadingSpinner({ size = 40, className = 'border-main' }: LoadingSpinnerProps) {
  return (
    <div
      aria-label='Đang tải'
      className={`animate-spin rounded-full border-2 border-t-transparent ${className}`}
      role='status'
      style={{ height: size, width: size, animationDuration: '0.5s' }}
    />
  );
}

type LoadingExportingProps = {
  message?: string;
};

export function LoadingExporting({ message = 'Đang kết xuất dữ liệu, vui lòng chờ...' }: LoadingExportingProps) {
  return (
    <div className='absolute inset-0 z-50 flex h-full w-full flex-col items-center justify-center bg-white'>
      <LoadingSpinner size={40} className='border-[#023e8a]' />
      <p className='mt-4 text-sm text-gray-600'>{message}</p>
    </div>
  );
}
